function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "classnames", "ramda", "react", "react-jss", "./SpinnerIcon.style"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("classnames"), require("ramda"), require("react"), require("react-jss"), require("./SpinnerIcon.style"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classnames, global.ramda, global.react, global.reactJss, global.SpinnerIcon);
    global.SpinnerIcon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classnames, _ramda, React, _reactJss, _SpinnerIcon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _classnames = _interopRequireDefault(_classnames);
  React = _interopRequireWildcard(React);
  _SpinnerIcon = _interopRequireDefault(_SpinnerIcon);
  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  var Icon = function Icon(props) {
    return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.9166666666666666s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(30 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.8333333333333334s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(60 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.75s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(90 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.6666666666666666s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(120 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.5833333333333334s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(150 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.5s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(180 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.4166666666666667s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(210 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.3333333333333333s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(240 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.25s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(270 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.16666666666666666s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(300 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "-0.08333333333333333s",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "33",
      y: "1",
      rx: "2",
      ry: "2",
      width: "4",
      height: "16",
      transform: "rotate(330 35 35)"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "opacity",
      values: "1;0",
      dur: "1s",
      begin: "0s",
      repeatCount: "indefinite"
    })));
  };
  Icon.defaultProps = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "70",
    viewBox: "0 0 70 70"
  };
  var useStyles = (0, _reactJss.createUseStyles)(_SpinnerIcon.default);
  var SpinnerIcon = function SpinnerIcon(_ref) {
    var className = _ref.className,
      small = _ref.small;
    var classes = useStyles();

    // Classes
    var rootClasses = (0, _classnames.default)(classes.root, className, _defineProperty({}, classes["root-small"], small));
    return /*#__PURE__*/React.createElement(Icon, {
      className: rootClasses
    });
  };
  var _default = (0, _ramda.compose)(React.memo)(SpinnerIcon);
  _exports.default = _default;
});